module.exports = "https://coursera_assets.s3.amazonaws.com/images/94d374b55f8a5d9bfbaaf42a578f7ac5.png";